import Font from "@/src/components/base/Font";
import styles from "./index.module.scss";
import CardLayanan from "../CardLayanan";
import { Fragment, useEffect, useRef } from "react";
import Skeleton from "@/src/components/tablet/Skeleton";
import Mosaics2 from "@/src/components/icons/Mosaics2";
import Mosaics3 from "@/src/components/icons/Mosaics3";
import { Service, WordStyling } from "@/src/utils/types/landingpage";

export default function LandingServices({
  services,
  loading,
  listWordStyling,
}: {
  services: Service[];
  loading: boolean;
  listWordStyling: WordStyling[];
}) {
  const titleRef = useRef(null);

  const callbackFn: IntersectionObserverCallback = (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(styles["visible"]);
        observer.unobserve(entry.target)
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFn);
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    return () => {
      if (titleRef.current) observer.unobserve(titleRef.current);
    };
  }, [titleRef]);

  return (
    <div className={styles["main-service-section"]}>
      <div className={styles["mosaics-2-wrapper"]}>
        <Mosaics2 />
      </div>
      <div className={styles["mosaics-3-wrapper"]}>
        <Mosaics3 />
      </div>
      <div
        ref={titleRef}
        className={styles["main-service-title"]}
      >
        <div className={styles["title-wrapper"]}>
          <Font variant="title-2-bold" color="black">
            3 Layanan Utama&nbsp;
          </Font>
          <Font variant="title-2-bold" color="orange1">
            BRIBrain
          </Font>
        </div>
        <div className={styles["title-wrapper"]}>
          <Font variant="subtitle-3-medium-1" color="dark40">
            Layanan ini disajikan dalam bentuk hasil data, API, dan&nbsp;
          </Font>
          <Font variant="subtitle-3-medium-1" color="dark40" fontStyle="italic">
            WebView
          </Font>
        </div>
      </div>
      <div className={styles["services-box-wrapper"]}>
        {services?.map((item, id) => (
          <Fragment key={id}>
            {loading ? (
              <Skeleton width={"100%"} height={250} radius={"24px"} />
            ) : (
              <CardLayanan
                src={`${process.env.NEXT_PUBLIC_IMAGES}/${item?.logo_layanan_utama}`}
                field={item?.title_layanan_utama}
                desc={item?.summary_layanan_utama}
                listWordStyling={listWordStyling}
                transitionDelay={`${0.25+id*0.5}s`}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
